import { catchError } from "../../utils/Helper";
import { product } from "../axios/endpoint";
import { deleteRequest, getRequest, postFormDataRequest, putFormDataRequest } from "../axios/request";
import { http } from "../axios/http";

export const getAllProducts = async (query, signal) => {
  try {
    const response = await getRequest(product.getAllProducts, query, signal);
    return response?.data;
  } catch (error) {
    throw catchError(error);
  }
};

export const createProduct = async (data) => {
  try {
    const response = await postFormDataRequest(product.createProduct, data);
    return response?.data;
  } catch (error) {
    throw catchError(error);
  }
};

export const updateProductById = async (id, data) => {
  try {
    const response = await putFormDataRequest(product.updateProductById(id), data);
    return response?.data;
  } catch (error) {
    throw catchError(error);
  }
};

export const deleteProductById = async (id) => {
  try {
    const response = await deleteRequest(product.deleteProductById(id));
    return response?.data;
  } catch (error) {
    throw catchError(error);
  }
};

export const getProductById = async (id) => {
  try {
    const response = await getRequest(product.getProductById(id));
    return response?.data;
  } catch (error) {
    throw catchError(error);
  }
};

export const deleteProductDocument = async (documentId) => {
  try {
    const response = await deleteRequest(product.deleteProductDocument(documentId));
    return response?.data;
  } catch (error) {
    throw catchError(error);
  }
};

export const deleteProductTaskDocument = async (documentId) => {
  try {
    const response = await deleteRequest(product.deleteProductTaskDocument(documentId));
    return response?.data;
  } catch (error) {
    throw catchError(error);
  }
};

export const downloadProductsCsv = async (queryParams = {}) => {
  try {
    const response = await http.get(product.exportProductDetails, {
      responseType: 'blob',
      params: queryParams
    });
    const filename = 'product.xlsx';
    const contentDisposition = response.headers['content-disposition'];    
    const url = window.URL.createObjectURL(response.data);
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    return response;
  } catch (error) {
    console.error('Download error:', error?.response || error);
    throw error;
  }
};

export const productApi = {
  getAllProducts,
  createProduct,
  updateProductById,
  deleteProductById,
  getProductById,
  deleteProductDocument,
  deleteProductTaskDocument,
  downloadProductsCsv
}; 